var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable camelcase */
import { proxy, unProxy } from 'ajax-hook';
import fetchInterceptor from 'fetch-intercept';
import { getQuery } from '../utils';
import { processProxyRequestConfig, processProxyResponseConfig } from './utils';
/**
 * 请求劫持初始化
 * @param packageJson 当前sdk版本号
 */
export var createRequestHooks = function (packageJson) {
    proxy({
        // 请求发起前进入
        onRequest: function (xhrConfig, handler) {
            // console.log(xhrConfig);
            var headers = xhrConfig.headers, url = xhrConfig.url, body = xhrConfig.body, method = xhrConfig.method;
            var query = getQuery(url);
            var requestConfig = { headers: headers, url: url, body: body, method: method, params: query };
            processProxyRequestConfig(requestConfig, packageJson).then(function (newConfig) {
                handler.next(__assign(__assign({}, xhrConfig), { url: newConfig === null || newConfig === void 0 ? void 0 : newConfig.url, body: newConfig === null || newConfig === void 0 ? void 0 : newConfig.body, headers: newConfig === null || newConfig === void 0 ? void 0 : newConfig.headers }));
            });
        },
        // 请求发生错误时进入，比如超时；注意，不包括http状态码错误，如404仍然会认为请求成功
        onError: function (err, handler) {
            handler.next(err);
        },
        // 请求成功后进入
        onResponse: function (response, handler) {
            // console.log(response);
            // const { headers, config } = response;
            var _a = response === null || response === void 0 ? void 0 : response.config, headers = _a.headers, url = _a.url, body = _a.body, method = _a.method;
            var query = getQuery(url);
            var requestConfig = { headers: headers, url: url, body: body, method: method, params: query };
            var responseConfig = {
                headers: response === null || response === void 0 ? void 0 : response.headers,
                config: requestConfig,
                response: response === null || response === void 0 ? void 0 : response.response,
            };
            var responseData = processProxyResponseConfig(responseConfig);
            handler.next(__assign(__assign({}, response), { headers: responseData === null || responseData === void 0 ? void 0 : responseData.headers, response: responseData === null || responseData === void 0 ? void 0 : responseData.response }));
        },
    });
    fetchInterceptor.register({
        request: function (url, fetchConfig) {
            return __awaiter(this, void 0, void 0, function () {
                var headers, body, method, query, requestConfig, newConfig;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            headers = fetchConfig.headers, body = fetchConfig.body, method = fetchConfig.method;
                            query = getQuery(url);
                            requestConfig = { headers: headers, url: url, body: body, method: method, params: query };
                            return [4 /*yield*/, processProxyRequestConfig(requestConfig, packageJson)];
                        case 1:
                            newConfig = _a.sent();
                            return [2 /*return*/, [url, __assign(__assign({}, fetchConfig), { url: newConfig === null || newConfig === void 0 ? void 0 : newConfig.url, body: newConfig === null || newConfig === void 0 ? void 0 : newConfig.body, headers: newConfig === null || newConfig === void 0 ? void 0 : newConfig.headers })]];
                    }
                });
            });
        },
        requestError: function (error) {
            // console.log('2222', error);
            // Called when an error occured during another 'request' interceptor call
            return Promise.reject(error);
        },
        response: function (response) {
            // Modify the reponse object
            var _a = response === null || response === void 0 ? void 0 : response.request, headers = _a.headers, url = _a.url, body = _a.body, method = _a.method;
            var query = getQuery(url);
            var requestConfig = { headers: headers, url: url, body: body, method: method, params: query };
            var responseConfig = {
                headers: response === null || response === void 0 ? void 0 : response.headers,
                config: requestConfig,
                response: response,
            };
            var responseData = processProxyResponseConfig(responseConfig);
            return __assign(__assign({}, response), { headers: responseData === null || responseData === void 0 ? void 0 : responseData.headers });
        },
        responseError: function (error) {
            // Handle an fetch error
            return Promise.reject(error);
        },
    });
};
export var deleteRequestHooks = function () {
    unProxy();
    fetchInterceptor.clear();
};
